/* tslint:disable */
/* eslint-disable */
/**
 * Document Simulation API
 * API for managing document simulations and contractualization strategies
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentViewItem } from './DocumentViewItem';
import {
    DocumentViewItemFromJSON,
    DocumentViewItemFromJSONTyped,
    DocumentViewItemToJSON,
    DocumentViewItemToJSONTyped,
} from './DocumentViewItem';

/**
 * 
 * @export
 * @interface GetDocumentViewItemsResponse
 */
export interface GetDocumentViewItemsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetDocumentViewItemsResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<DocumentViewItem>}
     * @memberof GetDocumentViewItemsResponse
     */
    items: Array<DocumentViewItem>;
}

/**
 * Check if a given object implements the GetDocumentViewItemsResponse interface.
 */
export function instanceOfGetDocumentViewItemsResponse(value: object): value is GetDocumentViewItemsResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetDocumentViewItemsResponseFromJSON(json: any): GetDocumentViewItemsResponse {
    return GetDocumentViewItemsResponseFromJSONTyped(json, false);
}

export function GetDocumentViewItemsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDocumentViewItemsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(DocumentViewItemFromJSON)),
    };
}

export function GetDocumentViewItemsResponseToJSON(json: any): GetDocumentViewItemsResponse {
    return GetDocumentViewItemsResponseToJSONTyped(json, false);
}

export function GetDocumentViewItemsResponseToJSONTyped(value?: GetDocumentViewItemsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(DocumentViewItemToJSON)),
    };
}

